import Card from "./Card";
import NavContent from "./NavContent";

function Nav() {
  return (
    <div className="passage-nav w-full h-16 translate-z-20 absolute top-0">
      <Card borderRadius="rounded-t-3xl" innerContent={<NavContent />}></Card>
    </div>
  );
}

export default Nav;
